import { createFileRoute } from '@tanstack/react-router'
import CopyProjectModalGate from '../../../../../components/copy-project-modal/copy-project-modal-gate'
import { copyProjectSearchSchema } from '../search-schemas'

export const Route = createFileRoute('/_authenticated/project/_projects/copy/')(
  {
    validateSearch: copyProjectSearchSchema,
    component: CopyProjectModalGate
  }
)
